import React from 'react';
import ExpansionContext from '../contexts/row-expand-context';

export default Component => () => (
  <ExpansionContext.Consumer>
    { expandRow => <Component { ...expandRow } /> }
  </ExpansionContext.Consumer>
);



// WEBPACK FOOTER //
// ./packages/react-bootstrap-table2/src/row-expand/expand-header-cell-consumer.js